function initSwiper(element, options) {
  const swiper = new Swiper(element, {
    allowTouchMove: true,
    direction: 'horizontal',
    grabCursor: true,
    loop: false,
    spaceBetween: 0.5,
    slidesPerView: 2.5,
    speed: 500,
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    scrollbar: {
      el: `${element} .swiper-scrollbar`,
      hide: false,
      draggable: true,
    },

    breakpoints: {
      1025: {
        slidesPerView: 4.5,
        spaceBetween: 1,
      },
    },
    ...options,
  });
}

initSwiper('.featured-products-swiper', {});

initSwiper(
  '.product-collection-swiper',
  {
    slidesPerView: 3.5,
    breakpoints: {
      1025: {
        slidesPerView: 6.5,
      },
    },
  },
);

initSwiper('predictive-search .product-collection-swiper', {});

initSwiper(
  '.prefooter--automatic-swiper',
  {
    allowTouchMove: false,
    loop: true,
    spaceBetween: 0,
    slidesPerView: 1,
    speed: 3000,
    autoplay: {
      delay: 1000,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      1025: {
        slidesPerView: 4,
        spaceBetween: 0,
        loop: false,
      },
    },
  },
);

initSwiper(
  '.prefooter--swiper',
  {
    loop: true,
    spaceBetween: 0,
    slidesPerView: 1,
    speed: 500,
    breakpoints: {
      1025: {
        slidesPerView: 4,
        spaceBetween: 0,
        loop: false,
      },
    },
  },
);

document.body.addEventListener('product-recommendations:loaded', () => {
  initSwiper('.product-recommendations--loaded .product-recommendations-swiper', {});
  swatchesEvents();
  addToWishlistEvent(document.querySelector('.product-recommendations--loaded .product-recommendations-swiper'));
});
